import type { ReactNode } from "react";

import { useSelector } from "metabase/redux";
import { getSetting } from "metabase/selectors/settings";

import DeprecationNotice from "../../containers/DeprecationNotice";

import { AdminIpBlocked } from "./AdminIpBlocked";

export interface AdminAppProps {
  children?: ReactNode;
}

const AdminApp = ({ children }: AdminAppProps): JSX.Element => {
  // 99digital: client-side navigation into /admin never reaches the server-side guard in
  // metabase.server.middleware.admin-ip-allowlist, so mirror it here. Enforcement still happens
  // on the server -- every admin API call is rejected by check-superuser -- this only keeps the
  // UI honest instead of rendering a shell full of failed requests.
  const isIpAllowed = useSelector((state) =>
    getSetting(state, "admin-panel-ip-allowed"),
  );

  if (isIpAllowed === false) {
    return <AdminIpBlocked />;
  }

  return (
    <>
      <DeprecationNotice />
      {children}
    </>
  );
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default AdminApp;
